const SKELETON = `
<div style="animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;margin-bottom:1.5rem;">
    <div><div style="height:0.75rem;width:3rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:12rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:8rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:6rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
    <div><div style="height:0.75rem;width:4rem;background:#e5e7eb;border-radius:0.25rem;margin-bottom:0.5rem;"></div><div style="height:1rem;width:5rem;background:#e5e7eb;border-radius:0.25rem;"></div></div>
  </div>
</div>`;

export default function userModal() {
  return {
    modalOpen: false,
    currentId: null,
    showCreateForm: false,
    createError: "",
    basePath: "/admin/users",

    init() {
      const match = window.location.pathname.match(/\/users\/([0-9a-f-]+)/);
      if (match) this.loadItem(match[1]);

      window.addEventListener("popstate", () => {
        const m = window.location.pathname.match(/\/users\/([0-9a-f-]+)/);
        if (m) {
          this._fetchIntoModal(this.basePath + "/" + m[1]);
          this.currentId = m[1];
          this.modalOpen = true;
        } else {
          this.modalOpen = false;
          this.currentId = null;
        }
      });
    },

    openItem(id) {
      history.pushState(null, "", this.basePath + "/" + id);
      this.loadItem(id);
    },

    loadItem(id) {
      this.currentId = id;
      this.showCreateForm = false;
      this.modalOpen = true;
      this._fetchIntoModal(this.basePath + "/" + id);
    },

    openCreateForm() {
      this.showCreateForm = true;
      this.createError = "";
      this.currentId = null;
    },

    closeCreateForm() {
      this.showCreateForm = false;
      this.createError = "";
    },

    async submitCreateUser() {
      this.createError = "";
      const form = this.$refs.createUserForm;
      const data = {
        email: form.email.value,
        password: form.password.value,
        first_name: form.first_name.value,
        last_name: form.last_name.value,
        username: form.username.value,
        is_superuser: form.is_superuser.checked,
      };
      try {
        const res = await fetch(this.basePath, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        const json = await res.json();
        if (!res.ok) {
          this.createError = json.error || "Failed to create user";
          return;
        }
        this.showCreateForm = false;
        window.location.reload();
      } catch {
        this.createError = "Network error";
      }
    },

    refreshModal() {
      if (this.currentId) {
        this._fetchIntoModal(this.basePath + "/" + this.currentId);
      }
    },

    closeModal() {
      this.modalOpen = false;
      this.currentId = null;
      history.pushState(null, "", this.basePath);
    },

    _fetchIntoModal(url) {
      const body = document.getElementById("modal-body");
      body.innerHTML = SKELETON;
      window.htmx.ajax("GET", url, "#modal-body");
    },
  };
}
